/* eslint-disable */
import {
  auditOnPlatformDevOrganization,
  foaQaAutomationAuditApiOrganization,
} from '../organizations';
import { artemisTestingOrganization } from '../test-organizations/internal-controls-test-organizations';
import { getLaunchpadUsers } from './test-user-base-info';
import { LaunchpadUser } from './types';

// General Audit on Platform users
export const agnesKovacsTestUser: LaunchpadUser = {
  email: 'agkovacs@diligent.com',
  password: 'asdQWE123',
  name: 'Ágnes Kovacs',
  firstName: 'Ágnes',
  lastName: 'Kovacs',
  initials: 'AK',
  highbondId: 'yCEPozU7jD1KHN617kc7',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: 'D0714005-FE69-4CB1-845D-029101AA70D1',
  organization: auditOnPlatformDevOrganization,
};

export const akosPinter55TestUser: LaunchpadUser = {
  email: 'apinter@diligent.com',
  password: 'asdQWE123',
  name: 'Ákos Pintér 55',
  firstName: 'Ákos',
  lastName: 'Pintér 55',
  initials: 'AP',
  highbondId: 'b65kW1AgzHPgsBCtvgZ7',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '3A27161E-D532-4DC6-AC35-76B6441166B7',
  organization: auditOnPlatformDevOrganization,
};

export const alejandroZamoraTestUser: LaunchpadUser = {
  email: 'azamora@diligent.com',
  password: 'asdQWE123',
  name: 'Alejandro Zamora',
  firstName: 'Alejandro',
  lastName: 'Zamora',
  initials: 'AZ',
  highbondId: 'c55Gfc48FTaULoLrqrjG',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: 'AAC0D7EE-FC5E-4C41-9D83-31C55D6DCF41',
  organization: auditOnPlatformDevOrganization,
};

export const almasiPatrikTestUser: LaunchpadUser = {
  email: 'palmasi@diligent.com',
  password: 'asdQWE123',
  name: 'Almási Patrik',
  firstName: 'Almási',
  lastName: 'Patrik',
  initials: 'AP',
  highbondId: 'R8RC2JVTeED_fZGWieD6',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: 'DDF087D7-58E4-44F5-A9DB-2D8EAAE808EC',
  organization: auditOnPlatformDevOrganization,
};

export const balazsBodnarTestUser: LaunchpadUser = {
  email: 'bbodnar@diligent.com',
  password: 'asdQWE123',
  name: 'Balázs Bodnár',
  firstName: 'Balázs',
  lastName: 'Bodnár',
  initials: 'BB',
  highbondId: 'zxswyZUFZb6VLxiZt6s4',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '7AC85499-EAE3-49B8-ABD8-903144DEFEB4',
  organization: auditOnPlatformDevOrganization,
};

// Balázs Bodnár's role-specific users
export const balazsBodnarAuditManagerTestUser: LaunchpadUser = {
  email: 'bbodnar-audit-manager@diligent.com',
  password: 'asdQWE123',
  name: 'Balázs Bodnár Audit Manager',
  firstName: 'Balázs',
  lastName: 'Bodnár Audit Manager',
  initials: 'BAM',
  highbondId: 'wLdVmz58DYmysgCxEZyv',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '33693DA5-495E-4E83-BA42-B8252E21FED5',
  organization: auditOnPlatformDevOrganization,
};

export const balazsBodnarAuditAuditorTestUser: LaunchpadUser = {
  email: 'bbodnar-audit-auditor@diligent.com',
  password: 'asdQWE123',
  name: 'Balázs Bodnár Audit Auditor',
  firstName: 'Balázs',
  lastName: 'Bodnár Audit Auditor',
  initials: 'BAA',
  highbondId: 'prPzHsP8hCxz4igcM7xR',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '98A5778A-8E76-4158-98F0-EBA2A1ADB3C2',
  organization: auditOnPlatformDevOrganization,
};

export const balazsBodnarAuditQaTestUser: LaunchpadUser = {
  email: 'bbodnar-audit-qa@diligent.com',
  password: 'asdQWE123',
  name: 'Balázs Bodnár Audit QA',
  firstName: 'Balázs',
  lastName: 'Bodnár Audit QA',
  initials: 'BAQ',
  highbondId: 'Qyr9faDB335youXs9jyN',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: 'D97EC73F-47A2-402C-A052-3EDF736796A9',
  organization: auditOnPlatformDevOrganization,
};

export const balazsBodnarHeadAuditTestUser: LaunchpadUser = {
  email: 'bbodnar-head-of-audit@diligent.com',
  password: 'asdQWE123',
  name: 'Balázs Bodnár Head Audit',
  firstName: 'Balázs',
  lastName: 'Bodnár Head Audit',
  initials: 'BHA',
  highbondId: 'cyGVSwzg9WZsbiP55gUe',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: 'BF302720-B983-4175-BE78-6555943F92D0',
  organization: auditOnPlatformDevOrganization,
};

// More general users
export const balazsGollnerTestUser: LaunchpadUser = {
  email: 'bgollner@diligent.com',
  password: 'asdQWE123',
  name: 'Balázs Göllner',
  firstName: 'Balázs',
  lastName: 'Göllner',
  initials: 'BG',
  highbondId: 'YtbcZVUn5dib-SBVML2e',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '45BA946C-266B-48A8-83EE-53A6D115E209',
  organization: auditOnPlatformDevOrganization,
};

export const carlosAlfonzoTestUser: LaunchpadUser = {
  email: 'calfonzo@diligent.com',
  password: 'asdQWE123',
  name: 'Carlos Alfonzo',
  firstName: 'Carlos',
  lastName: 'Alfonzo',
  initials: 'CA',
  highbondId: 'RLWj1MMwHDSt51VsMBVX',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '0FD01841-8AC3-4362-9E70-CBCB841FAF25',
  organization: auditOnPlatformDevOrganization,
};

export const davidGallegosTestUser: LaunchpadUser = {
  email: 'dgallegos@diligent.com',
  password: 'asdQWE123',
  name: 'David Gallegos',
  firstName: 'David',
  lastName: 'Gallegos',
  initials: 'DG',
  highbondId: '5PBztJY8qf5JQpxgAWkF',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: 'D6BB0E45-E0D4-4D20-A2A7-37BE88C1EABF',
  organization: auditOnPlatformDevOrganization,
};

export const dominikSaranTestUser: LaunchpadUser = {
  email: 'dsaran@diligent.com',
  password: 'asdQWE123',
  name: 'Dominik Saran',
  firstName: 'Dominik',
  lastName: 'Saran',
  initials: 'DS',
  highbondId: '_uD1kj_RR3RX5zHEf5ff',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: 'B5889DA4-77E1-4EAB-B49B-98F234587496',
  organization: auditOnPlatformDevOrganization,
};

export const dorottyaKovacsTestUser: LaunchpadUser = {
  email: 'dkovacs@diligent.com',
  password: 'asdQWE123',
  name: 'Dorottya Kovács',
  firstName: 'Dorottya',
  lastName: 'Kovács',
  initials: 'DK',
  highbondId: '-VwnhXJxZgZ9ibyZipsz',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '85039A3E-11A3-41E5-B862-A9092BAD21D0',
  organization: auditOnPlatformDevOrganization,
};

export const ezequielBarufTestUser: LaunchpadUser = {
  email: 'ebaruf@diligent.com',
  password: 'asdQWE123',
  name: 'Ezequiel Baruf',
  firstName: 'Ezequiel',
  lastName: 'Baruf',
  initials: 'EB',
  highbondId: 'Qpsx1VUxMeK_ddNsSxKd',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '4AC0B7B0-8A99-4D2F-BF57-C60A2802CA54',
  organization: auditOnPlatformDevOrganization,
};

export const johnBabiTestUser: LaunchpadUser = {
  email: 'jbabi@diligent.com',
  password: 'asdQWE123',
  name: 'John Babi',
  firstName: 'John',
  lastName: 'Babi',
  initials: 'JB',
  highbondId: 'Lhz8HjATMhk4Q2w9YHeT',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '30B3D524-8426-4E66-A94F-1F93019E08FD',
  organization: auditOnPlatformDevOrganization,
};

export const katalinTakacsTestUser: LaunchpadUser = {
  email: 'ktakacs@diligent.com',
  password: 'asdQWE123',
  name: 'Katalin Takács',
  firstName: 'Katalin',
  lastName: 'Takács',
  initials: 'KT',
  highbondId: 'oAaMQySdW3Jih3yVW8QD',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: 'BEB7E18B-8F9E-4E52-BE8A-B7112FB5C806',
  organization: auditOnPlatformDevOrganization,
};

export const laszloBendeTestUser: LaunchpadUser = {
  email: 'lbende@diligent.com',
  password: 'asdQWE123',
  name: 'László Bende',
  firstName: 'László',
  lastName: 'Bende',
  initials: 'LB',
  highbondId: 'yy5aJ9-a8dLrxWGmz6CN',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: 'B97B3766-73B1-4579-B110-E7A69A57C711',
  organization: auditOnPlatformDevOrganization,
};

export const matiasAlmeidaTestUser: LaunchpadUser = {
  email: 'malmeida@diligent.com',
  password: 'asdQWE123',
  name: 'Matias Almeida',
  firstName: 'Matias',
  lastName: 'Almeida',
  initials: 'MA',
  highbondId: '6bdPQEzWpKzAktXsaXSp',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '24959AB0-FE38-4E26-A7F1-0D4AC95C6E5B',
  organization: auditOnPlatformDevOrganization,
};

export const norbertTothTestUser: LaunchpadUser = {
  email: 'ntoth@diligent.com',
  password: 'asdQWE123',
  name: 'Norbert Tóth',
  firstName: 'Norbert',
  lastName: 'Tóth',
  initials: 'NT',
  highbondId: 'CBfyno31Yd24hyyzRo1y',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '76C13B6C-9401-447B-AA66-9803A9C3E040',
  organization: auditOnPlatformDevOrganization,
};

export const viktoriaOzsvartTestUser: LaunchpadUser = {
  email: 'vozsvart@diligent.com',
  password: 'asdQWE123',
  name: 'Viktoria Ozsvárt',
  firstName: 'Viktoria',
  lastName: 'Ozsvárt',
  initials: 'VO',
  highbondId: 'mcVkToFMZAKr6H-BRL59',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '2DB537D4-4613-44B7-B075-725BDF967517',
  organization: auditOnPlatformDevOrganization,
};

export const suchitraVasudevanTestUser: LaunchpadUser = {
  email: 'svasudevan@diligent.com',
  password: 'asdQWE123',
  name: 'Suchitra Vasudevan',
  firstName: 'Suchitra',
  lastName: 'Vasudevan',
  initials: 'SV',
  highbondId: 'zARnxZym-iqs6zhNKpxV',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: 'BF6CD0D9-6573-41A4-BBBA-81B8A58582AC',
  organization: auditOnPlatformDevOrganization,
};

export const noemiErdelyiTestUser: LaunchpadUser = {
  email: 'nerdelyi@diligent.com',
  password: 'asdQWE123',
  name: 'Noémi Erdélyi',
  firstName: 'Noémi',
  lastName: 'Erdélyi',
  initials: 'NE',
  highbondId: 'VEwKTLXyBc9Z1xuDxHzU',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: 'A06B5831-B374-4B77-BE35-95A8ABF987E5',
  organization: auditOnPlatformDevOrganization,
};

export const ferencForianSzaboTestUser: LaunchpadUser = {
  email: 'fforianszabo@diligent.com',
  password: 'asdQWE123',
  name: 'Ferenc Forián-Szabó',
  firstName: 'Ferenc',
  lastName: 'Forián-Szabó',
  initials: 'FF',
  highbondId: 'xkoK8sBZsmeuyBw53xMJ',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: 'C70CAE4B-6A12-4ADB-8841-D856CBCFAD65',
  organization: auditOnPlatformDevOrganization,
};

// FoA QA Automation specific users (assigned to org 767)
export const auditorTestUser: LaunchpadUser = {
  email: 'auditor@diligent.com',
  password: 'asdQWE123',
  name: 'Auditor',
  firstName: 'Auditor',
  lastName: 'User',
  initials: 'AU',
  highbondId: 'MU_CUM-Hv_JvBcEyA8nE',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: 'AFA91885-439A-4ABF-9E1F-4AA2049F6978',
  organization: foaQaAutomationAuditApiOrganization,
};

export const auditManagerTestUser: LaunchpadUser = {
  email: 'audit-manager@diligent.com',
  password: 'asdQWE123',
  name: 'Audit Manager',
  firstName: 'Audit',
  lastName: 'Manager',
  initials: 'AM',
  highbondId: 'xzQDs5uSpPyPd84sf7DB',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '49D169C0-04FD-4B1F-AA6C-1D768EEC862F',
  organization: foaQaAutomationAuditApiOrganization,
};

export const auditQaTestUser: LaunchpadUser = {
  email: 'audit-qa@diligent.com',
  password: 'asdQWE123',
  name: 'Audit QA',
  firstName: 'Audit',
  lastName: 'QA',
  initials: 'AQ',
  highbondId: 'x6P3nSws2QWjNWp5jjFh',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '5CED69C8-9921-41BD-9E3B-40EECB3BFB42',
  organization: foaQaAutomationAuditApiOrganization,
};

export const headOfAuditTestUser: LaunchpadUser = {
  email: 'vanguard-professional-user@test.com',
  password: 'asdQWE123',
  name: 'Head of Audit',
  firstName: 'Head of',
  lastName: 'Audit',
  initials: 'HA',
  highbondId: 'E_4Hzm3YJbgKoonkgByT',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '3579FD40-0623-45C8-BE60-4C122D28AA46',
  organization: foaQaAutomationAuditApiOrganization,
};

export const asomlaiTestUser: LaunchpadUser = {
  email: 'asomlai@diligent.com',
  password: 'asdQWE123',
  name: 'Andras Somlai',
  firstName: 'Andras',
  lastName: 'Somlai',
  initials: 'AS',
  highbondId: 'DQHf7VYCkB_me62LCodW',
  timezone: 'UTC',
  locale: 'en',
  dateFormat: 'YYYY-MM-DD',
  termsOfService: true,
  userType: 'user',
  id: '76C73B6C-9401-447B-AA66-9803A9C3E054',
  organization: auditOnPlatformDevOrganization,
  secondaryOrganizations: [artemisTestingOrganization],
};

// Environment-specific arrays for seeders
// All new audit users are dev-only per requirement
export const devAuditOnPlatformTestUsers = getLaunchpadUsers([
  // General users
  agnesKovacsTestUser,
  akosPinter55TestUser,
  alejandroZamoraTestUser,
  almasiPatrikTestUser,
  balazsBodnarTestUser,
  balazsBodnarAuditManagerTestUser,
  balazsBodnarAuditAuditorTestUser,
  balazsBodnarAuditQaTestUser,
  balazsBodnarHeadAuditTestUser,
  balazsGollnerTestUser,
  carlosAlfonzoTestUser,
  davidGallegosTestUser,
  dominikSaranTestUser,
  dorottyaKovacsTestUser,
  ezequielBarufTestUser,
  johnBabiTestUser,
  katalinTakacsTestUser,
  laszloBendeTestUser,
  matiasAlmeidaTestUser,
  norbertTothTestUser,
  asomlaiTestUser,
  viktoriaOzsvartTestUser,
  suchitraVasudevanTestUser,
  noemiErdelyiTestUser,
  ferencForianSzaboTestUser,
  // FoA QA specific users
  auditorTestUser,
  auditManagerTestUser,
  auditQaTestUser,
  headOfAuditTestUser,
]);
